export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/stats/Stats.vue'),
    meta: {
      resource: 'DashboardStats',
      action: 'read',
    },
  },
]
